import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsPullsOptions = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.pulls.options;

export const options = setCalculationModeAdminSettingsPullsOptions(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_PULLS_OPTIONS',
  []
);
